import offer from './offer-reducer';

export * from './offer-reducer';
export default offer;
